export interface LoadingScreenProps {
  progress: number
}

export const LoadingScreen = ({ progress }: LoadingScreenProps) => (
  <div className="bg-opacity-90 absolute inset-0 z-20 flex items-center justify-center bg-black">
    <div className="text-center text-white">
      <div className="mb-4 text-2xl">Loading Experience...</div>
      <div className="mb-2 h-2 w-64 rounded-full bg-gray-700">
        <div
          className="h-2 rounded-full bg-orange-500 transition-all duration-100"
          style={{
            width: `${progress}%`,
          }}
        ></div>
      </div>
      <div className="text-lg">{Math.round(progress)}%</div>
    </div>
  </div>
)
